// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import LotteryItemBase from "../common/LotteryItemBase";
import HappyWinItemBase from "./HappyWinItemBase";

const {ccclass, property} = cc._decorator;

@ccclass
export default class HappyWinItemCom extends LotteryItemBase {

	@property({ type: cc.Sprite, displayName:'' })
	nodeWin: cc.Sprite = null;

	@property({ type: cc.Label, displayName:'' })
	labelSum: cc.Label = null;

    @property(cc.Node)
    itemParent: cc.Node = null;

    itemBaseScript: HappyWinItemBase = null;

    private num = 0;
    private bWin = false;
    private card: number = 0;

    private bYetOpen = false;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.initUI();
    }

    setData(
        num: number
        , bWin: boolean
        , card: number
    ) {
        this.resetData();
        this.num = num;
        this.bWin = bWin;
        this.card = card;
        if (this.isInit()) {
            this.initUI();
        }
    }
    
    initUI() {
        this.nodeWin.node.active = false;
        this.labelSum.node.active = true;
        this.labelSum.string = data_control.getNumberFormat(this.num);
        this.itemBaseScript = this.itemParent.getChildByName('HappyWinItemBase').getComponent(HappyWinItemBase);
        this.itemBaseScript.setData(this.card);
    }

    resetData() {
        this.bOpenShow = false;
        this.bYetOpen = false;
        let children = this.judgeNode.children;
        for(let i = children.length-1; i >= 0; i--) {
            let nodeItem = children[i];
            nodeItem.active = true;
        }
    }

    showAward(multipe: number=1) {
        if (this.bWin && this.bYetOpen && !this.nodeWin.node.active) {
            this.nodeWin.node.active = true;
            this.openPrize(multipe);
        }
    }

    openPrize(multipe: number) {
        O1HD.getManagers().soundMgr.playSound("gglAddCoins").then();
        O1HD.getServices().userSrv.setCoins(this.num * multipe, true , this.node);
    }

    setYetOpen() {
        this.bYetOpen = true;
    }

    isYetOpen() {
        return this.bYetOpen;
    }

    // update (dt) {}
}
